import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, toHandlerKey as _toHandlerKey, mergeProps as _mergeProps, toDisplayString as _toDisplayString, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '../../assets/img/Popup/close.svg'


const _hoisted_1 = {
  key: 0,
  class: "modal__bg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "modal__draggable--thumb" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", { type: "button" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "modal__header"
}
const _hoisted_7 = { class: "modal__title" }
const _hoisted_8 = {
  key: 0,
  class: "modal__date"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M20 6C20 3.79086 18.2091 2 16 2H15V1C15 0.447715 14.5523 0 14 0C13.4477 0 13 0.447715 13 1V2H7V1C7 0.447715 6.55228 0 6 0C5.44772 0 5 0.447715 5 1V2H4C1.79086 2 0 3.79086 0 6V8V10V12.5V17C0 19.2091 1.79086 21 4 21H16C18.2091 21 20 19.2091 20 17V10V8V6ZM15 4H16C17.1046 4 18 4.89543 18 6V8H10.5H2V6C2 4.89543 2.89543 4 4 4H5C5 4.55228 5.44772 5 6 5C6.55228 5 7 4.55228 7 4H13C13 4.55228 13.4477 5 14 5C14.5523 5 15 4.55228 15 4ZM18 10V17C18 18.1046 17.1046 19 16 19H4C2.89543 19 2 18.1046 2 17V10.5V10H16H18Z",
    fill: "#667387"
  })
], -1)
const _hoisted_10 = {
  key: 1,
  class: "modal__extra"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  width: "6",
  height: "6",
  viewBox: "0 0 6 6",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("circle", {
  r: "3",
  transform: "matrix(1 0 0 -1 3 3)",
  fill: "#D7DAE1"
}, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { key: 2 }
const _hoisted_16 = {
  key: 0,
  class: "modal__card-mobile"
}
const _hoisted_17 = {
  key: 0,
  class: "modal__date"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M20 6C20 3.79086 18.2091 2 16 2H15V1C15 0.447715 14.5523 0 14 0C13.4477 0 13 0.447715 13 1V2H7V1C7 0.447715 6.55228 0 6 0C5.44772 0 5 0.447715 5 1V2H4C1.79086 2 0 3.79086 0 6V8V10V12.5V17C0 19.2091 1.79086 21 4 21H16C18.2091 21 20 19.2091 20 17V10V8V6ZM15 4H16C17.1046 4 18 4.89543 18 6V8H10.5H2V6C2 4.89543 2.89543 4 4 4H5C5 4.55228 5.44772 5 6 5C6.55228 5 7 4.55228 7 4H13C13 4.55228 13.4477 5 14 5C14.5523 5 15 4.55228 15 4ZM18 10V17C18 18.1046 17.1046 19 16 19H4C2.89543 19 2 18.1046 2 17V10.5V10H16H18Z",
    fill: "#667387"
  })
], -1)
const _hoisted_19 = {
  key: 1,
  class: "modal__extra"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  key: 1,
  width: "6",
  height: "6",
  viewBox: "0 0 6 6",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("circle", {
  r: "3",
  transform: "matrix(1 0 0 -1 3 3)",
  fill: "#D7DAE1"
}, null, -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { key: 2 }
const _hoisted_25 = ["innerHTML"]

import store from '@/store'
import {
  ref,
  onMounted,
  type Ref,
  watch,
  nextTick,
  onUnmounted,
  toRefs,
  onUpdated,
} from 'vue'
import { useBreakpoints, onClickOutside } from '@vueuse/core'
import MainMixin from '@/mixins/main'
import { handleLinkRedirect } from '@/main'


export default /*#__PURE__*/_defineComponent({
  __name: 'Popup',
  props: {
  open: {
    type: Boolean,
    default: false,
  },
  isAdmin: {
    type: Boolean,
    default: false,
  },
  cards: {
    type: Boolean,
    default: true,
  },
  feedback: {
    type: Boolean,
    default: false,
  },
  showContent: {
    type: Boolean,
    default: true,
  },
  mobfilters: {
    type: Boolean,
    default: false,
    desc: 'Prop for mobile filters',
  },
  showBg: {
    type: Boolean,
    default: true,
    desc: 'Prop for showing background',
  },
},
  emits: ['popupClose', 'closeContent'],
  setup(__props, { emit }) {

const props = __props;


onUnmounted(() => {
  store.dispatch('setCardItem', undefined)
  document.body.classList.remove('_locked')
}),
  watch(
    () => props.showContent,
    (value) => {}
  )


const breakpoints = useBreakpoints({
  tablet: 450,
  laptop: 1024,
  desktop: 1280,
})

const mobile = breakpoints.smaller('tablet')

const item: any = ref({
  cardName: '',
  cardDesc: '',
  cardTime: '',
  cityId: 0,
  cityName: '',
  sbeId: 0,
  sbeFullname: '',
  buttonText: '',
  offerUrl: '',
})
let dragPosition
const sheet = ref<Ref | null>(null)
const sheetContents = ref<Ref | null>(null)
const draggableArea = ref<Ref | null>(null)
const modalBody = ref<Ref | null>(null)
const modalContentRef = ref<Ref | null>(null)
const isContentOverflown = ref(false)
const { showContent } = toRefs(props)
const sheetHeightAuto = ref(0)

let sheetHeight, // in vh
  deltaHeight

onClickOutside(modalBody, () => {
  emit('closeContent')
})

const setIsSheetOverflown = () => {
  isContentOverflown.value =
    modalContentRef.value && isOverflown(modalContentRef.value)
}

const loadData = () => {
  if (props.feedback) return
  let cardItem = store.getters.getCardItem,
    cardName = '',
    cardDesc = '',
    cardTime = '',
    cityId = 0,
    cityName = '',
    sbeId = 0,
    sbeFullname = '',
    buttonText = '',
    offerUrl = ''
  if (!cardItem) return
  if (props.isAdmin) {
    cardName = cardItem.cardName
    cardDesc = cardItem.cardDesc
    cardTime = cardItem.cardTime
    cityId = cardItem.cityId
    cityName = cardItem.cityName
    sbeId = cardItem.sbeId
    sbeFullname = cardItem.sbeName
    buttonText = cardItem.buttonText
    offerUrl = cardItem.offerUrl
  } else {
    cardName = cardItem.getCardName()
    cardDesc = cardItem.getCardDesc()
    cardTime = cardItem.getUnlimDate()
      ? 'Бессрочно'
      : MainMixin.methods.getFormattedDateOriginFromTimestamp(
          cardItem.getDateFrom().getSeconds()
        ) +
        ' — ' +
        MainMixin.methods.getFormattedDateOriginFromTimestamp(
          cardItem.getDateTill().getSeconds()
        )
    cityId = cardItem.getCityId()
    cityName = cardItem.getCityName()
    sbeId = cardItem.getSbeId()
    sbeFullname = cardItem.getSbeName()
    buttonText = cardItem.getButtonText()
    offerUrl = cardItem.getOfferUrl()
  }

  item.value = {
    cardName: cardName,
    cardDesc: cardDesc,
    cardTime: cardTime,
    cityId: cityId,
    cityName: cityName,
    sbeId: sbeId,
    sbeFullname: sbeFullname,
    buttonText: buttonText,
    offerUrl: offerUrl,
  }
}

onMounted(() => {
  if (!props.cards) {
    store.dispatch('setCardItem', undefined)
  }
  loadData()
})
onUpdated(() => {
  addEventToLinks()
})
const addEventToLinks = () => {
  const links: any = document.querySelectorAll('.modal__content-h a')
  links.forEach((link) => {
    link.style.cursor = 'pointer'
    link.addEventListener('click', (e) => {
      e.preventDefault()

      handleLinkRedirect(link.href)
    })
  })
}

const setSheetHeight = (value) => {
  sheetHeight = Math.max(0, Math.min(100, value))
  if (value === 'auto') {
    sheetHeight = (100 * sheetContents.value.offsetHeight) / window.innerHeight
    // sheetContents.value.style.height = sheetHeight
    sheetContents.value.style.transform = `translate(0px,0px)`
    sheetHeightAuto.value = sheetHeight
  }
  // sheetContents.value.style.height = `${sheetHeight}vh`
  sheetContents.value.style.transform = `translateY(${value}px)`
  // if (sheetHeight === 100) {
  //   sheetContents.value.classList.add('fullscreen')
  // } else {
  //   sheetContents.value.classList.remove('fullscreen')
  // }
}
const touchPosition = (event) => (event.touches ? event.touches[0] : event)

const onDragStart = (event) => {
  dragPosition = touchPosition(event).clientY
  sheetContents.value.classList.add('not-selectable')
  modalContentRef.value.classList.add('lock-scroll')
  draggableArea.value.style.cursor = document.body.style.cursor = 'grabbing'
}
const onDragMove = (event) => {
  if (dragPosition === undefined) return
  const y = touchPosition(event).clientY
  const deltaY = y - dragPosition

  if (deltaY > 0) {
    deltaHeight = deltaY
  } else {
    deltaHeight = 0
  }
  setSheetHeight(deltaHeight)
  // dragPosition = y
}
const onDragEnd = () => {
  dragPosition = undefined
  if (deltaHeight > sheetContents.value.clientHeight * 0.5) {
    sheetContents.value.style.transform = `translateY(100%)`
    sheetContents.value.style.transform = `transition .3s ease`
    emit('closeContent')
  } else {
    sheetContents.value.style.transform = `translateY(0px)`
  }
  sheetContents.value.classList.remove('not-selectable')
  modalContentRef.value.classList.remove('lock-scroll')
  draggableArea.value.style.cursor = document.body.style.cursor = ''
}
const setIsSheetShown = (value: boolean) => {
  if (value === false) emit('popupClose')
  loadData()
  setSheetHeight('auto')

  value === true
    ? document.body.classList.add('_locked')
    : document.body.classList.remove('_locked')
}
const isOverflown = ({
  clientWidth,
  clientHeight,
  scrollWidth,
  scrollHeight,
}) => {
  return scrollHeight > clientHeight || scrollWidth > clientWidth
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "sheet",
    ref: sheet,
    class: "modal"
  }, [
    (__props.showBg)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    _createVNode(_Transition, {
      name: _unref(mobile) ? 'mobile-content' : 'content',
      onEnter: _cache[3] || (_cache[3] = ($event: any) => (setIsSheetShown(true))),
      onAfterEnter: setIsSheetOverflown,
      onLeave: _cache[4] || (_cache[4] = ($event: any) => (emit('popupClose')))
    }, {
      default: _withCtx(() => [
        (_unref(showContent))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              ref_key: "sheetContents",
              ref: sheetContents,
              class: _normalizeClass(["modal__contents", {
          'modal__contents--shadow': !_unref(showContent),
          'modal__contents--mobfilters': __props.mobfilters,
          'modal__contents--feedback': __props.feedback,
        }])
            }, [
              _createElementVNode("div", {
                ref_key: "modalBody",
                ref: modalBody,
                class: _normalizeClass(["modal__body", {
            'modal__body--cards': __props.cards,
          }])
              }, [
                _createElementVNode("div", _mergeProps({ [_toHandlerKey(_unref(mobile)&&`mousedown`)]: onDragStart }, { [_toHandlerKey(_unref(mobile)&&`touchstart`)]: onDragStart }, { [_toHandlerKey(_unref(mobile)&&`mousemove`)]: onDragMove }, { [_toHandlerKey(_unref(mobile)&&`touchmove`)]: onDragMove }, { [_toHandlerKey(_unref(mobile)&&`mouseup`)]: onDragEnd }, { [_toHandlerKey(_unref(mobile)&&`touchend`)]: onDragEnd }, { class: "modal__controls" }), [
                  _createElementVNode("div", {
                    ref_key: "draggableArea",
                    ref: draggableArea,
                    class: "modal__draggable--area"
                  }, _hoisted_3, 512)
                ], 16),
                _createElementVNode("div", {
                  class: "modal__close",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('closeContent')))
                }, _hoisted_5),
                (item.value.cardName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, _toDisplayString(item.value.cardName || ''), 1),
                      (!_unref(mobile) && item.value.cardTime !== 'Бессрочно')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _hoisted_9,
                            _createElementVNode("p", null, _toDisplayString(item.value.cardTime || ''), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (
                (!_unref(mobile) &&
                  (item.value.cityName !== 'Вся Россия' ||
                    item.value.sbeFullname !== 'Все СБЕ')) ||
                (!_unref(mobile) &&
                  item.value.cityName !== 'Вся Россия' &&
                  item.value.sbeFullname !== 'Все СБЕ')
              )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            (item.value.cityName !== 'Вся Россия')
                              ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(item.value.cityName || ''), 1))
                              : _createCommentVNode("", true),
                            (
                  item.value.cityName !== 'Вся Россия' &&
                  item.value.sbeFullname !== 'Все СБЕ'
                )
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_12, _hoisted_14))
                              : _createCommentVNode("", true),
                            (item.value.sbeFullname !== 'Все СБЕ')
                              ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(item.value.sbeFullname || ''), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  ref_key: "modalContentRef",
                  ref: modalContentRef,
                  class: _normalizeClass(["modal__content", { 'modal__content--feedback': __props.feedback }])
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["modal__content-h", {
                'modal__body--cards': __props.cards,
              }])
                  }, [
                    (_unref(mobile) && item.value.cardName)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          (item.value.cardTime !== 'Бессрочно')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _hoisted_18,
                                _createElementVNode("p", null, _toDisplayString(item.value.cardTime || ''), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (
                    item.value.cityName !== 'Вся Россия' ||
                    item.value.sbeFullname !== 'Все СБЕ' ||
                    (item.value.cityName !== 'Вся Россия' &&
                      item.value.sbeFullname !== 'Все СБЕ')
                  )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                (item.value.cityName !== 'Вся Россия')
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(item.value.cityName || ''), 1))
                                  : _createCommentVNode("", true),
                                (
                      item.value.cityName !== 'Вся Россия' &&
                      item.value.sbeFullname !== 'Все СБЕ'
                    )
                                  ? (_openBlock(), _createElementBlock("svg", _hoisted_21, _hoisted_23))
                                  : _createCommentVNode("", true),
                                (item.value.sbeFullname !== 'Все СБЕ')
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(item.value.sbeFullname || ''), 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (item.value.cardDesc)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          innerHTML: item.value.cardDesc || ''
                        }, null, 8, _hoisted_25))
                      : _renderSlot(_ctx.$slots, "default", { key: 2 })
                  ], 2)
                ], 2),
                (item.value.cardName)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(["modal__bottom--button", {
              'modal-bottom-shadow': isContentOverflown.value,
              'modal__bottom--close': !item.value.offerUrl,
            }])
                    }, [
                      (item.value.offerUrl)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_unref(handleLinkRedirect)(item.value.offerUrl)), ["prevent"]))
                          }, _toDisplayString(item.value.buttonText || 'Перейти'), 1))
                        : (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('closeContent')))
                          }, "Закрыть"))
                    ], 2))
                  : _createCommentVNode("", true)
              ], 2)
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["name"])
  ], 512))
}
}

})